import { render, staticRenderFns } from "./CoinAccount.vue?vue&type=template&id=58ab23e3&scoped=true"
import script from "./CoinAccount.vue?vue&type=script&lang=ts"
export * from "./CoinAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab23e3",
  null
  
)

export default component.exports